export interface DeductionItemProps {
  id: number;
  notes: string;
  poDate: string;
  quantity: number;
  allowance: string;
  packSize: string;
  poNumber: string;
  shipDate: string;
  unitCost: number;
  createdAt: string;
  expiryDate: string;
  itemNumber: string;
  refInvoice: string;
  deductionId: number;
  invoiceDate: string;
  totalAmount: number;
  receivedDate: string;
  retailerName: string;
  invoiceAmount: number;
  orderQuantity: number;
  additionalData: string;
  costDifference: number;
  retailerNumber: string;
  upcItemNumber: string;
  itemDescription: string;
  receivedUnitCost: number;
  distributionCenter: string;
  quantityDifference: number;
  discount: string;
  divisionName: string;
  divisionNumber: string;
  units: number;
  ship: string;
  productCategoryName: string | null;
  isValidityFailed?: boolean | null;
  validityRcas?: Array<{ id: number; code: string; rcaDescription: string }> | null;
}
export class DeductionItem implements DeductionItemProps {
  private readonly _id: number;
  private readonly _notes: string;
  private readonly _poDate: string;
  private readonly _quantity: number;
  private readonly _allowance: string;
  private readonly _packSize: string;
  private readonly _poNumber: string;
  private readonly _shipDate: string;
  private readonly _unitCost: number;
  private readonly _createdAt: string;
  private readonly _expiryDate: string;
  private readonly _itemNumber: string;
  private readonly _refInvoice: string;
  private readonly _deductionId: number;
  private readonly _invoiceDate: string;
  private readonly _totalAmount: number;
  private readonly _receivedDate: string;
  private readonly _retailerName: string;
  private readonly _invoiceAmount: number;
  private readonly _orderQuantity: number;
  private readonly _additionalData: string;
  private readonly _costDifference: number;
  private readonly _retailerNumber: string;
  private readonly _upcItemNumber: string;
  private readonly _itemDescription: string;
  private readonly _receivedUnitCost: number;
  private readonly _distributionCenter: string;
  private readonly _quantityDifference: number;
  private readonly _discount: string;
  private readonly _divisionName: string;
  private readonly _divisionNumber: string;
  private readonly _units: number;
  private readonly _ship: string;
  private readonly _productCategoryName: string | null;
  private readonly _isValidityFailed: boolean;
  private readonly _validityRcas: Array<{ id: number; code: string; rcaDescription: string }>;

  constructor(props: DeductionItemProps) {
    this._id = props.id;
    this._notes = props.notes;
    this._poDate = props.poDate;
    this._quantity = props.quantity ? Number(props.quantity) : props.quantity;
    this._allowance = props.allowance;
    this._packSize = props.packSize;

    this._poNumber = props.poNumber;
    this._shipDate = props.shipDate;
    this._unitCost = props.unitCost ? Number(props.unitCost) : props.unitCost;
    this._createdAt = props.createdAt;
    this._expiryDate = props.expiryDate;
    this._itemNumber = props.itemNumber;
    this._refInvoice = props.refInvoice;
    this._deductionId = props.deductionId;
    this._invoiceDate = props.invoiceDate;
    this._totalAmount = props.totalAmount ? Number(props.totalAmount) : props.totalAmount;
    this._receivedDate = props.receivedDate;
    this._retailerName = props.retailerName;
    this._invoiceAmount = props.invoiceAmount ? Number(props.invoiceAmount) : props.invoiceAmount;
    this._orderQuantity = props.orderQuantity ? Number(props.orderQuantity) : props.orderQuantity;
    this._additionalData = props.additionalData;
    this._costDifference = props.costDifference ? Number(props.costDifference) : props.costDifference;

    this._retailerNumber = props.retailerNumber;
    this._upcItemNumber = props.upcItemNumber;
    this._itemDescription = props.itemDescription;
    this._receivedUnitCost = props.receivedUnitCost ? Number(props.receivedUnitCost) : props.receivedUnitCost;
    this._distributionCenter = props.distributionCenter;
    this._quantityDifference = props.quantityDifference ? Number(props.quantityDifference) : props.quantityDifference;

    this._discount = props.discount;
    this._divisionName = props.divisionName;
    this._divisionNumber = props.divisionNumber;
    this._units = props.units ? Number(props.units) : props.units;
    this._ship = props.ship;
    this._productCategoryName = props.productCategoryName;
    this._isValidityFailed = Boolean(props.isValidityFailed);
    this._validityRcas = props.validityRcas ?? [];
  }

  public get id(): number {
    return this._id;
  }

  public get notes(): string {
    return this._notes;
  }

  public get poDate(): string {
    return this._poDate;
  }

  public get quantity(): number {
    return this._quantity;
  }

  public get allowance(): string {
    return this._allowance;
  }

  public get packSize(): string {
    return this._packSize;
  }

  public get poNumber(): string {
    return this._poNumber;
  }

  public get shipDate(): string {
    return this._shipDate;
  }

  public get unitCost(): number {
    return this._unitCost;
  }

  public get createdAt(): string {
    return this._createdAt;
  }

  public get expiryDate(): string {
    return this._expiryDate;
  }

  public get itemNumber(): string {
    return this._itemNumber;
  }

  public get refInvoice(): string {
    return this._refInvoice;
  }

  public get deductionId(): number {
    return this._deductionId;
  }

  public get invoiceDate(): string {
    return this._invoiceDate;
  }

  public get totalAmount(): number {
    return this._totalAmount;
  }

  public get receivedDate(): string {
    return this._receivedDate;
  }

  public get retailerName(): string {
    return this._retailerName;
  }

  public get invoiceAmount(): number {
    return this._invoiceAmount;
  }

  public get orderQuantity(): number {
    return this._orderQuantity;
  }

  public get additionalData(): string {
    return this._additionalData;
  }

  public get costDifference(): number {
    return this._costDifference;
  }

  public get retailerNumber(): string {
    return this._retailerNumber;
  }

  public get upcItemNumber(): string {
    return this._upcItemNumber;
  }

  public get itemDescription(): string {
    return this._itemDescription;
  }

  public get receivedUnitCost(): number {
    return this._receivedUnitCost;
  }

  public get distributionCenter(): string {
    return this._distributionCenter;
  }

  public get quantityDifference(): number {
    return this._quantityDifference;
  }

  public get discount(): string {
    return this._discount;
  }

  public get divisionName(): string {
    return this._divisionName;
  }

  public get divisionNumber(): string {
    return this._divisionNumber;
  }

  public get units(): number {
    return this._units;
  }

  public get ship(): string {
    return this._ship;
  }

  public get productCategoryName(): string | null {
    return this._productCategoryName;
  }

  public get isValidityFailed(): boolean {
    return this._isValidityFailed;
  }

  public get validityRcas(): Array<{ id: number; code: string; rcaDescription: string }> {
    return this._validityRcas;
  }

  public static isDeductionItem(obj: DeductionItemProps): obj is DeductionItem {
    return obj instanceof DeductionItem;
  }

  public static createDeductionItem(props: DeductionItemProps): DeductionItem {
    return new DeductionItem(props);
  }
}
